export default __webpack_public_path__ + "static/media/lock2.490d5942.jpg";